import AccountsBlock from './AccountsBlock';

export default AccountsBlock;
